import { combineReducers } from "redux";
import spreedlyReducer, { initialState } from "data/spreedly";

export default combineReducers({
  spreedly: spreedlyReducer,
});
